<div class="card card-custom">
    <div class="card-header">
        <div class="card-title">
            <h3 class="card-label">{{data.title}}</h3>
        </div>
    </div>
    <div class="form">
        <div class="card-body">
            <form [formGroup]="form">
                <div class="form-group row">
                    <div class="col-lg-6 kt-margin-bottom-10-mobile">
                        <mat-form-field class="mat-form-field-fluid">
                            <input matInput placeholder="Invoice Number" formControlName="invoice_number" autocomplete="off"/>
                            <mat-error>
                                Invoice Number
                                <strong>required</strong>
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-lg-6 kt-margin-bottom-10-mobile">
                        <mat-form-field class="mat-form-field-fluid">
                            <input matInput placeholder="Amount" formControlName="amount"
                                [allowNegativeNumbers]="false" mask="separator.2" thousandSeparator=","
                                [suffix]="data.currency ? ' (' + data.currency + ')' : ''"/>
                            <mat-error>
                                Amount
                                <strong>required</strong>
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <input #fileInput type="file" hidden (change)="onUpload($event)"
                    accept=".pdf,.jpeg,.jpg,.png,.doc,.docx,.xls,.xlsx"/>
                <div class="form-group row">
                    <div class="col-12 d-flex align-items-center" style="gap: 1rem;">
                        <button type="button" mat-raised-button color="primary" (click)="onClickUpload()"
                            [disabled]="uploading">
                            Upload File
                        </button>
                        <div class="d-flex align-items-center" style="gap: 0.5rem">
                            <span class="font-weight-bold">File name:</span>
                            <span style="color: green" *ngIf="fileDisplayName">{{fileDisplayName}}</span>
                            <span style="color: red" *ngIf="!fileDisplayName">N/A</span>
                            <button type="button" mat-icon-button color="warn" matTooltip="Remove file"
                                (click)="removeFile()" *ngIf="fileDisplayName">
                                <mat-icon>close</mat-icon>
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>

        <div class="card-footer b-0 p-0 text-right">
            <div class="form-actions form-actions-solid">
                <div class="row">
                    <div class="col-lg-12">
                        <button mat-button (click)="onNoClick()">
                            Close
                        </button>
                        <button mat-button (click)="save()" color="primary">
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
